import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Bell, BellRing, Loader2, Trash2, Search, Plus } from "lucide-react";

function filtersToQuery(f) {
  const p = new URLSearchParams();
  Object.entries(f || {}).forEach(([k, v]) => { if (v !== null && v !== "" && v !== undefined) p.set(k, v); });
  return p.toString();
}

export default function Alertas() {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/alerts").then(({ data }) => setAlerts(data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const verCarros = async (a) => {
    try { await api.post(`/alerts/${a.id}/seen`); } catch {}
    navigate(`/buscar?${filtersToQuery(a.filters)}`);
  };

  const remover = async (id) => {
    try { await api.delete(`/alerts/${id}`); toast.success("Alerta removido"); load(); }
    catch { toast.error("Erro ao remover"); }
  };

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10" data-testid="alertas-page">
      <p className="overline text-blaze mb-2">Fique por dentro</p>
      <div className="flex items-end justify-between gap-4 mb-8">
        <h1 className="font-heading font-800 text-3xl md:text-4xl">Meus Alertas de Carro</h1>
        <Button variant="outline" className="rounded-sm border-obsidian/15 font-600" onClick={() => navigate("/buscar")} data-testid="alertas-buscar-btn">
          <Plus className="w-4 h-4 mr-1" /> Criar na busca
        </Button>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-blaze" /></div>
      ) : alerts.length === 0 ? (
        <div className="bg-white border border-border rounded-sm p-16 text-center">
          <Bell className="w-10 h-10 text-muted-foreground mx-auto" strokeWidth={1.5} />
          <p className="mt-4 text-muted-foreground">Você ainda não tem alertas. Faça uma busca e salve seus filtros para ser avisado quando entrar um carro novo.</p>
          <Button className="mt-5 bg-obsidian hover:bg-blaze text-white rounded-sm" onClick={() => navigate("/buscar")} data-testid="empty-alerta-btn">Buscar carros</Button>
        </div>
      ) : (
        <div className="space-y-3">
          {alerts.map((a) => (
            <div key={a.id} className="bg-white border border-border rounded-sm p-5 flex items-center gap-4" data-testid={`alert-card-${a.id}`}>
              <div className={`w-11 h-11 rounded-sm flex items-center justify-center shrink-0 ${a.new_count > 0 ? "bg-blaze text-white" : "bg-secondary text-muted-foreground"}`}>
                {a.new_count > 0 ? <BellRing className="w-5 h-5" /> : <Bell className="w-5 h-5" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="font-700 truncate">{a.name}</p>
                  {a.new_count > 0 && <Badge className="bg-blaze hover:bg-blaze text-white rounded-sm" data-testid={`alert-new-${a.id}`}>{a.new_count} novo(s)</Badge>}
                </div>
                <p className="text-sm text-muted-foreground mt-0.5">{a.total} carro(s) correspondem a este alerta</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <Button size="sm" className="rounded-sm bg-obsidian hover:bg-blaze text-white" onClick={() => verCarros(a)} data-testid={`alert-ver-${a.id}`}>
                  <Search className="w-4 h-4 mr-1" /> Ver
                </Button>
                <AlertDialog>
                  <AlertDialogTrigger asChild>
                    <Button size="sm" variant="ghost" className="rounded-sm text-blaze hover:text-blaze" data-testid={`alert-delete-${a.id}`}><Trash2 className="w-4 h-4" /></Button>
                  </AlertDialogTrigger>
                  <AlertDialogContent>
                    <AlertDialogHeader>
                      <AlertDialogTitle>Remover alerta?</AlertDialogTitle>
                      <AlertDialogDescription>Você deixará de ser avisado sobre "{a.name}".</AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                      <AlertDialogCancel>Cancelar</AlertDialogCancel>
                      <AlertDialogAction className="bg-blaze hover:bg-obsidian" onClick={() => remover(a.id)}>Remover</AlertDialogAction>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialog>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
